module.exports = __webpack_public_path__ + "img/sstp.9367e2ea.png";